import { Building2, Warehouse, Factory, Wrench, Briefcase, Building } from 'lucide-react';
import React from "react";

import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";


import { getJobDisputedOffers } from "../../../../../../services/staffingService";

const UnassignedListView = ({ data }) => {
  const [open, setOpen] = useState(false);
  const [getByItem, setGetByItem] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const { providerCompanyId } = useParams();
  const [disputedOffers, setDisputedOffers] = useState([]);

  useEffect(() => {
    if (!open) {
      setGetByItem(null);
    }
  }, [open]);

  function getFacilityIcon(facilityType, fallbackSeed) {
    // Map facility types to Material UI icons
    const facilityIcons = {
      workplace: Briefcase,
      warehouse: Warehouse,
      office: Building2,
      factory: Factory,
      construction: Wrench
    };
  
    // Convert the keys of facilityIcons to an array
    const availableTypes = Object.keys(facilityIcons);
  
    // If the facilityType exists, use it; otherwise, choose a consistent icon based on seed
    let SelectedIcon;
    if (facilityIcons[facilityType]) {
      SelectedIcon = facilityIcons[facilityType];
    } else {
      // Use a deterministic approach instead of random - use the fallbackSeed to get consistent icon
      const index = Math.abs((fallbackSeed || 'default').split('').reduce((a, b) => a + b.charCodeAt(0), 0)) % availableTypes.length;
      SelectedIcon = facilityIcons[availableTypes[index]];
    }
  
    // Return the icon component or default icon
    return SelectedIcon || Building;
  }

  return (
    <div className="font-inter">
      <table className="w-full border-separate" style={{ borderSpacing: '0 16px' }}>
        <thead>
          <tr>
            <th className="text-sm font-normal text-gray-600 border-0 px-3 text-left">Location</th>
            <th className="text-sm font-normal text-gray-600 border-0 px-3 text-left">Status</th>
          </tr>
        </thead>
        <tbody id="data-body">
          {data.length > 0 &&
            data.map((job, index) => {
              const shiftsText = `${job.statistics.totalShiftsInJob} shift${
                job.statistics.totalShiftsInJob !== 1 ? "s" : ""
              }`;

              return (
                <React.Fragment key={job._id || index}>
                  <tr className="bg-white">
                    <td className="p-3 border-0 rounded-l-lg align-middle">
                      <div className="flex items-center gap-2">
                        <div className="profile">
                          <div className="relative w-14 h-14 rounded-2xl bg-gradient-to-br from-primary/10 via-brand-blue-light/30 to-white border border-primary/20 shadow-lg flex items-center justify-center group hover:shadow-xl hover:shadow-brand-pink/20 transition-all duration-300 hover:scale-105 hover:rotate-3">
                            <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-transparent to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            {React.createElement(getFacilityIcon(job.customer_company_id?.facilityType, job._id || job.customer_company_id?.companyFriendlyName || 'default'), {
                              className: "relative z-10 w-7 h-7 text-primary group-hover:text-brand-pink transition-all duration-300 group-hover:scale-110",
                              style: { 
                                filter: 'drop-shadow(0 2px 4px rgba(64, 72, 128, 0.15))'
                              }
                            })}
                          </div>
                        </div>
                        <div>
                          <h4 className="text-base font-medium text-black mb-0.5">
                            {job.customer_company_id.companyFriendlyName}
                          </h4>
                          <p className="text-sm font-normal text-gray-500 m-0">
                            {job.formattedAddress}
                          </p>
                        </div>
                      </div>
                    </td>

                    <td className="p-3 border-0 rounded-r-lg align-middle">
                      {job.statistics.offerCounts.disputed > 0 ? (
                        <div className="flex flex-col items-end gap-2">
                          {/* Disputed Badge */}
                          <div className="flex items-center gap-2">
                            <span className="w-5 h-5 rounded-full bg-pink-600 text-white text-xs font-bold flex items-center justify-center">
                              {job.statistics.offerCounts.disputed}
                            </span>
                            <span className="text-sm font-medium text-pink-600">
                              Disputed Offers
                            </span>
                          </div>

                          <Link
                            to={`/provider-company/${providerCompanyId}/jobs/${job._id}`}
                            className="text-xs text-blue-600 hover:text-blue-800 underline font-medium"
                          >
                            Resolve Now
                          </Link>
                        </div>
                      ) : (
                        <div className="flex justify-end">
                          <span className="text-sm font-normal text-gray-500">No Disputed Offers</span>
                        </div>
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
        </tbody>
      </table>

      {/* <SideDrawer isOpen={open} setIsOpen={setOpen} getByItem={getByItem} /> */}
    </div>
  );
};

export default UnassignedListView;
